<template>
  
  <div class="accounts">

      <v-content class="pa-10">

        <v-row no-gutters>
            <div class="headline text-capitalize pb-5">Emails</div>
            <v-spacer></v-spacer>
            <v-btn class="blue-grey" dark @click="addDialog = true" >Add New Record</v-btn>
        </v-row>

        <v-data-table :headers="headers" :items="accounts" :search="search" :items-per-page="$store.state.itemPerPage" :loading="tableLoading" class="elevation-1">
            
            <!-- password -->
            <template v-slot:item.password="{ item }">
                <span v-if="!item.lock">{{ item.password }}</span>
                <span v-if="item.lock">{{ item.password | hidePwd }}</span>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" class="pl-2" @click="toggleAccess(item.id, 'pwd')"><v-icon>mdi-eye</v-icon></v-btn>
                    </template>
                    <span>Show Password</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" class="pl-4" v-clipboard="item.password" @success="copied" :disabled="item.lock"><v-icon>mdi-content-copy</v-icon></v-btn>
                    </template>
                    <span>Copy Password</span>
                </v-tooltip>
            </template>

            <template v-slot:item.remark="{ item }">
                <span class="d-inline-block text-truncate" style="max-width: 300px;">{{ item.remark }} </span>
            </template>
            
            <!-- actions -->
            <template v-slot:item.action="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" @click="toggleAccess(item.id, 'edit')"><v-icon>mdi-file-document-edit</v-icon></v-btn>
                    </template>
                    <span>Edit Record</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" @click="toggleAccess(item.id, 'del')"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <span>Delete</span>
                </v-tooltip>
            </template>

        </v-data-table>

        <!-- dialog modals -->

        <new-email v-if="addDialog" :dialog="addDialog" @dialogHide="closeDialog()" :counter="counter"></new-email>

        <edit-email v-if="editDialog" :recuid="recordUID" :dialog="editDialog" @dialogHide="closeDialog()"></edit-email>

        <v-dialog v-model="accessDialog" width="500">
            <v-card>
                <v-card-text class="pt-5">
                    <v-text-field v-model="code" label="Please Enter Secret Code" required @keyup.enter="togglePassword(codeIndex, codeType)" autofocus></v-text-field>
                    <div v-if="accessWrong" class="red--text">Code is incorrect! Try again</div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn dark @click="closeDialog()">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="blue-grey white--text" @click="togglePassword(codeIndex, codeType)">Verify</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- snackbars -->

        <v-snackbar top v-model="snackbar" :timeout="2000"> 
            Password Copied
        </v-snackbar>

        <v-snackbar v-model="$store.state.snackSuccess" :timeout="2000" top color="teal" dark>
            Success!
        </v-snackbar>

        <v-snackbar top v-model="$store.state.snackDelete" :timeout="2000" dark> 
            Record Deleted!
        </v-snackbar>

      </v-content>

  </div>

</template>

<script>
import newEmail from '../components/newEmail'
import editEmail from '../components/editEmail'
import { auth, db } from '@/plugins/appfirebase'

export default {

    components: { newEmail, editEmail },

    mounted() {

        // request data table values
        this.requestData();

        // request codes from server
        this.$store.dispatch('requestCodes');

    },

    data() {
        return {
            headers: [
            { text: 'ID', value: 'id', width: '7%' },
            { text: 'Full Name', value: 'fullname', width: '10%' },
            { text: 'E-Mail Account', value: 'email', width: '10%' },
            { text: 'Password', value: 'password', width: '15%', align: 'right' },
            { text: 'Use For', value: 'usefor', width: '10%' },
            { text: 'Phone Number', value: 'phone', width: '15%' },
            { text: 'Remark', value: 'remark', width: '23%' },
            { text: '', value: 'action', width: '10%', align: 'right' },
            ],
            accounts: this.$store.state.emails,
            search: '',
            selectedUser: '',
            users: [],
            tableLoading: true,
            recordUID: '',          // Props to pass record UID to components
            counter: 0,             // To find table record lastest UID

            code: '',
            codeIndex: '',
            codeType: '',
            snackbar: false,

            addDialog: false,
            editDialog: false,
            accessDialog: false,
            accessWrong: false,

            mydb: db.collection('email').doc(auth.currentUser.uid).collection('data')
        }
    },

    methods: {

        requestData() {

            this.accounts = []; // clear array accounts data

            this.mydb.onSnapshot( queries => {
                
                let changes = queries.docChanges(); // detect new changes

                changes.forEach( change => {
                    if(change.type == 'added') {
                        this.accounts.unshift(change.doc.data()); // unshift: push new element to the beginning of an array
                        this.accounts.sort((a,b) => ((+a.id) < (+b.id)) ? 1 : (((+b.id) < (+a.id)) ? -1 : 0)); // sort in the correct way
                    } else if ( change.type == 'removed') {
                        this.accounts = this.accounts.filter( item => { return item.id != change.doc.id })
                    } else if ( change.type == 'modified') {
                        
                        // remove the editing record
                        this.accounts = this.accounts.filter( item => { return item.id != change.doc.id }) 
                        // then, add the modified record to the top of the data
                        this.accounts.unshift(change.doc.data()) 
                        this.accounts.sort((a,b) => ((+a.id) < (+b.id)) ? 1 : (((+b.id) < (+a.id)) ? -1 : 0)); // sort in the correct way
            
                    }
                })
                this.tableLoading = false
                this.counter = this.accounts.length ? this.accounts[0].id : 0 // setting counter to the last record id
            })
        },
        deleteData(id) {
            this.mydb.doc(id.toString()).delete().then( () => { this.$store.state.snackDelete = true; })
        },

        toggleAccess(id, type) {

            // set current record UID
            this.recordUID = id
            
            // Find index of a record by id
            let i = this.accounts.map( (key) => { return key.id; }).indexOf(id);

            if ( this.accounts[i].lock == true ) {      // if record is locked for hidden
                this.accessDialog = true                // then open dialog to verify code
                this.codeIndex = id                     // then set the record id
                this.codeType = type                    // and set record type
            }

            if ( this.accounts[i].lock == false ) {                 // if record is unlocked
                this.accounts[i].lock = !this.accounts[i].lock;     // then turn the record to lock for hidden
            }
            
        },
        togglePassword(id, type) {
            
            // get code from store data
            let codes = this.$store.state.codes;

            if (type == 'pwd' && this.code == codes.pwd ) { 

                let i = this.accounts.map( (key) => { return key.id; }).indexOf(id);
                this.accounts[i].lock = !this.accounts[i].lock;
                this.accessDialog = !this.accessDialog

            } else if ( type == 'edit' && this.code == codes.edit ) {

                this.accessDialog = false
                this.editDialog = true

            } else if ( type == 'del' && this.code == codes.edit ) { 

                this.accessDialog = false
                this.deleteData(id)

            } else {
                this.accessWrong = true
            }
            this.code = ''
        },
        copied() {
            this.snackbar = true;
        },
        closeDialog() {
            this.accessDialog = false
            this.addDialog = false
            this.editDialog = false

            this.accessWrong = false
        }
    },
    filters: {
        hidePwd(string) {
            return string.replace(/./g, "*");
        }
    }
}
</script>
